import React, { useState } from 'react'

import { graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

import Img from '../components/Img'
import Input from '../components/Input'
import Button from '../components/Button'

const JoinUsSection = ({ slice }) => {
  const { primary } = slice

  const [value, setValue] = useState('')
  const [success, setSuccess] = useState(false)

  const submitForm = () => {
    console.log('submit', value)
    setSuccess(true)
    setTimeout(() => {
      setSuccess(false)
    }, 3000)
  }

  return (
    <section
      className={`section joinus-section joinus-section-${primary?.theme} ${primary?.page}`}
    >
      <div className="container">
        <div className="joinus-box">
          <div className="info-wrapper">
            <h3 className="title">{primary?.title1?.text}</h3>
            <p className="p p-16">{primary?.description?.text}</p>
          </div>
          <div className="input-box-wrapper">
            <div className="input-container">
              <Input
                type={primary?.input_type}
                placeholder={primary?.input_placeholder.text}
                value={value}
                onChange={(value) => {
                  setValue(value)
                }}
                label={primary?.input_label?.text}
                required={primary?.required}
              />
              <Button data={primary} callback={submitForm} />
            </div>

            <div className="contact-form-info-text">
              <PrismicRichText
                field={primary?.info_text.richText}
              ></PrismicRichText>
            </div>
            {success ? (
              <div className="contact-form-success-block">
                <h4 className="">{primary.success_message.text}</h4>
              </div>
            ) : null}
          </div>
          {primary.background_image && (
            <Img
              image={primary.background_image.gatsbyImageData}
              alt={primary.background_image.alt}
              className="background-image"
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default JoinUsSection

export const query = graphql`
  fragment CareersPageDataBodyJoinUsSection on PrismicCareersPageDataBodyJoinUsSection {
    id
    primary {
      theme
      title1 {
        text
      }
      success_message {
        text
      }
      required
      input_type
      input_placeholder {
        text
      }
      input_label {
        text
      }
      info_text {
        richText
      }
      description {
        text
      }
      button_title {
        text
      }
      button_theme
      background_image {
        gatsbyImageData
        alt
      }
    }
    slice_type
  }
  fragment ArticlesOverviewPageDataBodyJoinUsSection on PrismicArticlesOverviewPageDataBodyJoinUsSection {
    id
    primary {
      theme
      title1 {
        text
      }
      success_message {
        text
      }
      required
      input_type
      input_placeholder {
        text
      }
      input_label {
        text
      }
      info_text {
        richText
      }
      description {
        text
      }
      button_title {
        text
      }
      button_theme
      background_image {
        gatsbyImageData
        alt
      }
    }
    slice_type
  }
  fragment ArticlesSearchPageDataBodyJoinUsSection on PrismicArticlesSearchPageDataBodyJoinUsSection {
    id
    primary {
      theme
      title1 {
        text
      }
      success_message {
        text
      }
      required
      input_type
      input_placeholder {
        text
      }
      input_label {
        text
      }
      info_text {
        richText
      }
      description {
        text
      }
      button_title {
        text
      }
      button_theme
      background_image {
        gatsbyImageData
        alt
      }
    }
    slice_type
  }
  fragment ArticlePageDataBodyJoinUsSection on PrismicArticlePageDataBodyJoinUsSection {
    id
    primary {
      theme
      title1 {
        text
      }
      success_message {
        text
      }
      required
      input_type
      input_placeholder {
        text
      }
      input_label {
        text
      }
      info_text {
        richText
      }
      description {
        text
      }
      button_title {
        text
      }
      button_theme
      background_image {
        gatsbyImageData
        alt
      }
    }
    slice_type
  }
  fragment ArticlePageDataBody1JoinUsSection on PrismicArticlePageDataBody1JoinUsSection {
    id
    primary {
      theme
      title1 {
        text
      }
      success_message {
        text
      }
      required
      input_type
      input_placeholder {
        text
      }
      input_label {
        text
      }
      info_text {
        richText
      }
      description {
        text
      }
      button_title {
        text
      }
      button_theme
      background_image {
        gatsbyImageData
        alt
      }
    }
    slice_type
  }
  fragment AuthorPageDataBodyJoinUsSection on PrismicAuthorPageDataBodyJoinUsSection {
    id
    primary {
      theme
      title1 {
        text
      }
      success_message {
        text
      }
      required
      input_type
      input_placeholder {
        text
      }
      input_label {
        text
      }
      info_text {
        richText
      }
      description {
        text
      }
      button_title {
        text
      }
      button_theme
      background_image {
        gatsbyImageData
        alt
      }
    }
    slice_type
  }
`
